import type { CssGeneratorContext } from '../css-generator.model';

/**
 * The `app-tree-select` trigger draws the library select box (`.p-select`); it shows the library's focused box while
 * the panel is open (`.p-focus`) and, with the same declarations, while the keyboard focuses it. The tree rows take
 * the theme's focus ring on keyboard focus (the library tree's node ring, outside the row).
 */
export const styles = ({ dt }: CssGeneratorContext) => `.app-treeselect {
  display: flex;
  flex: 1;
  min-width: 0px;

  & .treeselect-button {
    display: flex;
    flex: 1;
    min-width: 0px;

    & span.clear-icon {
      color: ${dt('select.clear.icon.color')};
    }
  }
}

.app-treeselect .treeselect-button .p-select:not(.p-disabled):focus-visible {
  border-color: ${dt('select.focus.border.color')};
  box-shadow: ${dt('select.focus.ring.shadow')};
  outline: ${dt('select.focus.ring.width')} ${dt('select.focus.ring.style')} ${dt('select.focus.ring.color')};
  outline-offset: ${dt('select.focus.ring.offset')};
}

/* A leading field icon (iconValue): the icon field lays the trigger out as the tree select's row does, so the trigger
   stretches with the row and the icon centres on the trigger box. The trigger is a large field (.p-inputfield-lg),
   which the library icon field answers with a larger icon, so the icon takes back the size of an icon-led text field. */
.app-treeselect .treeselect-iconfield {
  display: flex;
}

.app-treeselect .treeselect-iconfield > .p-inputicon:first-child {
  font-size: ${dt('icon.size')};
  width: ${dt('icon.size')};
  height: ${dt('icon.size')};
  margin-top: calc(-1 * (${dt('icon.size')} / 2));
}

.treeselect-tree-row:focus-visible {
  box-shadow: ${dt('focus.ring.shadow')};
  outline: ${dt('focus.ring.width')} ${dt('focus.ring.style')} ${dt('focus.ring.color')};
  outline-offset: ${dt('focus.ring.offset')};
}

/* Optimus writes the trigger's width as an inline min-width on the panel, so it never gets narrower than the trigger. */
.treeselect-overlay-fit-content {
  width: max-content;
  max-width: min(56rem, calc(100vw - 2rem));
}

/* A reserved gutter is part of the scroll container's max-content width, so a vertical scrollbar cannot push rows into horizontal overflow. */
.treeselect-overlay-fit-content [data-treeselect-scroll-container] {
  scrollbar-gutter: stable;
}
`;
